"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeType = exports.WithdrawalStatus = exports.DepositStatus = exports.DepositLimitPeriodInterval = exports.WithdrawalResolveCode = exports.DepositResolveCode = exports.WithdrawalResolveBy = exports.DepositResolveBy = exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Manual"] = "Manual";
    PaymentProvider["Correction"] = "Correction";
    PaymentProvider["BankTransfer"] = "BankTransfer";
    PaymentProvider["CryptoAPI"] = "CryptoAPI";
    PaymentProvider["CashierCryptoAPI"] = "CashierCryptoAPI";
    PaymentProvider["CashierBankTransfer"] = "CashierBankTransfer";
    PaymentProvider["PixAPI"] = "PixAPI";
    PaymentProvider["TolaAPI"] = "TolaAPI";
    PaymentProvider["GumBallPay"] = "GumBallPay";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
var DepositResolveBy;
(function (DepositResolveBy) {
    DepositResolveBy["Admin"] = "Admin";
    DepositResolveBy["PixApi"] = "PixApi";
    DepositResolveBy["Pagfast"] = "Pagfast";
    DepositResolveBy["WyraPay"] = "WyraPay";
    DepositResolveBy["Paybrokers"] = "Paybrokers";
    DepositResolveBy["Internal"] = "Internal";
})(DepositResolveBy || (exports.DepositResolveBy = DepositResolveBy = {}));
var WithdrawalResolveBy;
(function (WithdrawalResolveBy) {
    WithdrawalResolveBy["Admin"] = "Admin";
    WithdrawalResolveBy["PixApi"] = "PixApi";
    WithdrawalResolveBy["Pagfast"] = "Pagfast";
    WithdrawalResolveBy["WyraPay"] = "WyraPay";
    WithdrawalResolveBy["Paybrokers"] = "Paybrokers";
    WithdrawalResolveBy["Internal"] = "Internal";
    WithdrawalResolveBy["CryptoApi"] = "CryptoApi";
    WithdrawalResolveBy["TolaAPI"] = "TolaApi";
})(WithdrawalResolveBy || (exports.WithdrawalResolveBy = WithdrawalResolveBy = {}));
var DepositResolveCode;
(function (DepositResolveCode) {
    DepositResolveCode["Unknown"] = "Unknown";
    DepositResolveCode["ManualReject"] = "ManualReject";
    DepositResolveCode["PixApiReject"] = "PixApiReject";
    DepositResolveCode["TolaApiReject"] = "TolaApiReject";
})(DepositResolveCode || (exports.DepositResolveCode = DepositResolveCode = {}));
var WithdrawalResolveCode;
(function (WithdrawalResolveCode) {
    WithdrawalResolveCode["Unknown"] = "Unknown";
    WithdrawalResolveCode["ManualReject"] = "ManualReject";
    WithdrawalResolveCode["PixApiReject"] = "PixApiReject";
    WithdrawalResolveCode["CreditTransactionError"] = "CreditTransactionError";
    WithdrawalResolveCode["TolaApiReject"] = "TolaApiReject";
})(WithdrawalResolveCode || (exports.WithdrawalResolveCode = WithdrawalResolveCode = {}));
var DepositLimitPeriodInterval;
(function (DepositLimitPeriodInterval) {
    DepositLimitPeriodInterval[DepositLimitPeriodInterval["NONE"] = 0] = "NONE";
    DepositLimitPeriodInterval[DepositLimitPeriodInterval["DAY"] = 1] = "DAY";
    DepositLimitPeriodInterval[DepositLimitPeriodInterval["WEEK"] = 7] = "WEEK";
    DepositLimitPeriodInterval[DepositLimitPeriodInterval["MONTH"] = 30] = "MONTH";
})(DepositLimitPeriodInterval || (exports.DepositLimitPeriodInterval = DepositLimitPeriodInterval = {}));
var DepositStatus;
(function (DepositStatus) {
    DepositStatus["Draft"] = "Draft";
    DepositStatus["AddressApproved"] = "AddressApproved";
    DepositStatus["Pending"] = "Pending";
    DepositStatus["Approved"] = "Approved";
    DepositStatus["Rejected"] = "Rejected";
})(DepositStatus || (exports.DepositStatus = DepositStatus = {}));
var WithdrawalStatus;
(function (WithdrawalStatus) {
    WithdrawalStatus["Draft"] = "Draft";
    WithdrawalStatus["Approved"] = "Approved";
    WithdrawalStatus["Completed"] = "Completed";
    WithdrawalStatus["Rejected"] = "Rejected";
})(WithdrawalStatus || (exports.WithdrawalStatus = WithdrawalStatus = {}));
var FeeType;
(function (FeeType) {
    FeeType["None"] = "None";
    FeeType["Slow"] = "Slow";
    FeeType["Standard"] = "Standard";
    FeeType["Fast"] = "Fast";
})(FeeType || (exports.FeeType = FeeType = {}));
//# sourceMappingURL=payment.js.map